import { Breadcrumbs } from "AbstractElements"
import FAQProgramContain from "Component/Learning/FAQProgram/FAQProgramContain"

const FAQProgramList = () => {
  return (
    <>
      <Breadcrumbs title="FAQ Program" />
      <FAQProgramContain />
    </>
  )
}

export default FAQProgramList